import { Link } from "react-router-dom";
import { useState } from "react";
import logo from "./Logo.png";
/* eslint-disable */

function Header() {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);
  const closeNav = () => setIsNavCollapsed(true);

  return (
    <header>
      <nav
        className="navbar navbar-expand-lg navbar-light shadow-sm"
        style={{ backgroundColor: "#ceffb8" }}
      >
        <div className="container">
          {/* Logo */}
          <Link to="/">
            <img
              className="mb-3"
              src={logo}
              alt="Logo"
              style={{ height: "80px" }}
            />
          </Link>

          {/* Toggler Button for Mobile */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded={!isNavCollapsed}
            aria-label="Toggle navigation"
            onClick={handleNavCollapse}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navigation Links */}
          <div
            className={`collapse navbar-collapse justify-content-end ${
              isNavCollapsed ? "" : "show"
            }`}
            id="navbarNav"
            style={{ fontFamily: "Jost, sans-serif", fontWeight: 400 }}
          >
            <ul
              className="navbar-nav"
              style={{
                gap: "15px",
                display: "flex",
                alignItems: "center",
                fontSize: "20px",
              }}
            >
              <li className="nav-item">
                <Link className="nav-link nav-text" to="/" onClick={closeNav}>
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link nav-text"
                  to="events"
                  onClick={closeNav}
                >
                  Events
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link nav-text"
                  to="program"
                  onClick={closeNav}
                >
                  Programs
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link nav-text"
                  to="gallery"
                  onClick={closeNav}
                >
                  Gallery
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link nav-text"
                  to="aboutUs"
                  onClick={closeNav}
                >
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link nav-text"
                  to="donate"
                  onClick={closeNav}
                >
                  Contribute
                </Link>
              </li>
              <li className="nav-item">
                <Link to="joinUs" onClick={closeNav}>
                  <button
                    className="btn btn-success text-white ms-lg-3"
                    style={{ padding: "5px 15px", fontFamily: "Poppins" }}
                  >
                    Join Us!
                  </button>
                </Link>
              </li>
              <li className="nav-item ms-4">
                <button
                  className="btn btn-outline-success d-flex align-items-center"
                  style={{
                    borderWidth: "2px",
                    fontSize: "14px",
                    padding: "5px 10px",
                    fontWeight: 600,
                  }}
                  onClick={closeNav}
                >
                  <i
                    className="bi bi-globe me-2"
                    style={{ fontSize: "16px" }}
                  ></i>
                  DE
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
